import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  või &lt;a href='/info/ei\_leidnud\_sobivat\_toodet'&gt;Kliki siia&lt;/a&gt; ja me aitame sind sobiva toote leidmisel.

  <span style="color:#85c1dc;">**FI:**</span>
  tai &lt;a href='/info/sopivaa tuotetta ei löytynt'&gt;Klikkaa tästä&lt;/a&gt; ja autamme sinua sopivan tuotteen löytämisessä.

  <span style="color:#85c1dc;">**RU:**</span>
  или &lt;a href='/info/подходящий\_товар\_не\_найден'&gt;Нажмите здесь&lt;/a&gt; и мы поможем вам найти нужный товар.
*/
/* @__NO_SIDE_EFFECTS__ */
const m1210 = msg(
  mf`või <a href='/info/ei_leidnud_sobivat_toodet'>Kliki siia</a> ja me aitame sind sobiva toote leidmisel.`,
  mf`tai <a href='/info/sopivaa tuotetta ei löytynt'>Klikkaa tästä</a> ja autamme sinua sopivan tuotteen löytämisessä.`,
  mf`или <a href='/info/подходящий_товар_не_найден'>Нажмите здесь</a> и мы поможем вам найти нужный товар.`,
)

export { m1210 as 'w.module.no-results.search.bottom-text' }